import React from "react";
import PageHero from "../components/PageHero";
import { heroImages, company } from "../mock";
import SEO from "../components/SEO";

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="How Ruken Alazdehar General Trading LLC collects, uses and protects your personal information."
        path="/privacy-policy"
      />
      <PageHero
        title="Privacy Policy"
        subtitle="How Ruken Alazdehar collects, uses and protects your information."
        breadcrumbs={[{ label: "Privacy Policy" }]}
        bgImage={heroImages.contact}
      />
      <section className="section-padding bg-white">
        <div className="max-w-3xl mx-auto px-6 prose prose-neutral">
          <p className="text-sm text-muted-foreground">Last updated: January 2025</p>
          <h2 className="font-display text-2xl font-bold text-brand mt-8" style={{ color: "var(--brand-700)" }}>1. Introduction</h2>
          <p className="text-foreground/80 leading-relaxed mt-3">
            Ruken Alazdehar General Trading LLC (“we”, “us”, or “our”) respects your privacy. This Privacy Policy describes how we collect, use, disclose, and safeguard your information when you visit our website or engage with our trading services.
          </p>
          <h2 className="font-display text-2xl font-bold text-brand mt-8" style={{ color: "var(--brand-700)" }}>2. Information We Collect</h2>
          <p className="text-foreground/80 leading-relaxed mt-3">
            We may collect personal information that you voluntarily provide to us through our forms, including: name, designation, email address, phone number, company details, and trade-related preferences such as product specifications, destination ports, and payment terms.
          </p>
          <h2 className="font-display text-2xl font-bold text-brand mt-8" style={{ color: "var(--brand-700)" }}>3. How We Use Your Information</h2>
          <p className="text-foreground/80 leading-relaxed mt-3">
            We use the information we collect to respond to your inquiries, process supplier registrations, provide quotations, maintain customer relationships, and improve our services. We do not sell your personal information to third parties.
          </p>
          <h2 className="font-display text-2xl font-bold text-brand mt-8" style={{ color: "var(--brand-700)" }}>4. Cookies & Analytics</h2>
          <p className="text-foreground/80 leading-relaxed mt-3">
            We use cookies and similar tracking technologies to track activity on our website and store certain information to enhance the user experience. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
          </p>
          <h2 className="font-display text-2xl font-bold text-brand mt-8" style={{ color: "var(--brand-700)" }}>5. Data Security</h2>
          <p className="text-foreground/80 leading-relaxed mt-3">
            We implement appropriate technical and organisational measures to protect your personal data against unauthorised or unlawful processing and against accidental loss, destruction or damage.
          </p>
          <h2 className="font-display text-2xl font-bold text-brand mt-8" style={{ color: "var(--brand-700)" }}>6. Your Rights</h2>
          <p className="text-foreground/80 leading-relaxed mt-3">
            Depending on your jurisdiction, you may have the right to access, correct or delete your personal data, or object to certain processing activities. To exercise these rights, please contact us at <a href={`mailto:${company.email}`} style={{ color: "var(--brand-500)" }}>{company.email}</a>.
          </p>
          <h2 className="font-display text-2xl font-bold text-brand mt-8" style={{ color: "var(--brand-700)" }}>7. Contact</h2>
          <p className="text-foreground/80 leading-relaxed mt-3">
            For questions about this Privacy Policy, contact us at {company.address}, phone {company.phone}, or email <a href={`mailto:${company.email}`} style={{ color: "var(--brand-500)" }}>{company.email}</a>.
          </p>
        </div>
      </section>
    </>
  );
}
